<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import {
  setWechatTitle, getSession,
} from '@/utils'

export default {
  computed: {
    ...mapState(['userInfo', 'loading']),
  },
  created() {
    setWechatTitle('知我探索')
    this.init()
  },
  methods: {
    ...mapMutations(['SET_USER_INFO']),
    init() {
      let userInfo = getSession('USER_INFO')
      if (userInfo) {
        userInfo = JSON.parse(userInfo)
        this.SET_USER_INFO(userInfo)
      }
      // this.$showLoading()
      // console.log(this.loading)
    },
  },
}
</script>
<style lang="less">
@import '~@/assets/less/base.less';
.app-loading{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  z-index: @loading-zindex;
}
</style>
